
<div class="dashboard-content" style="padding: 120px 40px 50px">

  <div class="mb-3" routerLink="/add-contents">
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none">
      <rect width="52" height="52" rx="26" fill="#F5F5F9" />
      <path d="M18 26H34" stroke="#586277" stroke-width="1.53752" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M23 31C23 31 18 27.3176 18 26C18 24.6824 23 21 23 21" stroke="#586277" stroke-width="1.53752"
        stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </div>


  <div class="row contests-container">
    <div class="col-12">
      <div class="contests-header d-flex justify-content-between align-items-center">
        <h1>Participant Profile</h1>
      </div>
    </div>
    <div class="col-12">
      <div class="">
        <div class="content-card">
          <div class="head">
            <div class="main">
              <div class="profile-card d-flex align-items-center">
                <div class="profile-info ms-3">
                  <h5 class="name mb-1">Cristofer Carder</h5>
                </div>
              </div>

              <div class="container profile-details py-4">
                <div class="row">
                  <div class="row">
                    <div class="col-xl-5">
                      <div class="row">
                        <div class="left-side col-4">
                          <ul class="list-unstyled mb-0">
                            <li>Gender</li>
                            <li>Age</li>
                            <li>Location</li>
                            <li>Contest</li>
                            <li>Type</li>
                            <li>Levels</li>
                          </ul>
                        </div>
                        <div class="left-data col-8">
                          <ul class=" mb-0">
                            <li>Male</li>
                            <li>28</li>
                            <li>United Kingdom</li>
                            <li>Champions’ Quest</li>
                            <li>Private</li>
                            <li>2 level</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-xl-7">
                      <div class="row">
                        <div class="left-side col-4">
                          <ul class="list-unstyled mb-0">
                            <li>Prize</li>
                            <li>Total Points</li>
                            <li>Time duration</li>
                            <li>Previously</li>
                            <li>Rating</li>
                            <li>Feedback</li>
                          </ul>
                        </div>
                        <div class="left-data col-8">
                          <ul class=" mb-0">
                            <li>LCD</li>
                            <li>455</li>
                            <li>00:15:78</li>
                            <li>Already played 8 contest </li>
                            <li>4/5</li>
                            <li>"Participating in the contest was an exciting and seamless experience; it truly brought
                              out
                              the best of my skills!"</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>
              </div>


            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</div>